import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const colorConfig: Record<string, { bg: string; iconBg: string; iconColor: string; border: string }> = {
    primary: { bg: 'hover:bg-primary-50/60', iconBg: 'bg-primary-100', iconColor: 'text-primary-600', border: 'border-primary-200/60' },
    accent: { bg: 'hover:bg-accent-50/60', iconBg: 'bg-accent-100', iconColor: 'text-accent-600', border: 'border-accent-200/60' },
    secondary: { bg: 'hover:bg-secondary-50/60', iconBg: 'bg-secondary-100', iconColor: 'text-secondary-600', border: 'border-secondary-200/60' },
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            全类型资源覆盖
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            六大资源分类，海量数据库实时更新，满足你的多样化搜索需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => {
            const colors = colorConfig[cat.color];
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group p-5 md:p-6 rounded-xl bg-background-50 border ${colors.border} ${colors.bg} transition-all duration-300`}
              >
                <div className="flex items-start gap-4">
                  <div className={`w-11 h-11 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${colors.iconBg} ${colors.iconColor}`}>
                    <i className={`${cat.icon} text-lg md:text-xl`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-1.5">
                      <h3 className="text-base md:text-lg font-semibold font-heading text-foreground-900">
                        {cat.name}
                      </h3>
                      <span className="text-xs text-foreground-400 flex-shrink-0 ml-2">
                        {cat.count.toLocaleString()}条
                      </span>
                    </div>
                    <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                      {cat.description}
                    </p>
                    <div className="flex flex-wrap gap-1.5">
                      {cat.keywords.slice(0, 4).map((kw) => (
                        <span
                          key={kw}
                          className="px-2 py-0.5 text-xs rounded-md bg-background-100 text-foreground-600"
                        >
                          {kw}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}